import React, { FC, PropsWithChildren } from 'react';
import { ErrorValidation, TreeNodeType } from '../lib/types/types';

interface StrapiForm {
	application: any;
	schulJahrDetails: any;
	setApplicationProperty: (key: string, value: any) => void;
	saveApplication: (submit?: boolean, newApplication?: boolean | any, changeLastEdited?: boolean) => void;
	handlePrint: () => void;
	readOnly: boolean;
	printMode: boolean;
	tree: TreeNodeType[];
	errors: ErrorValidation[];
	// setCheckboxChecked?: (checked: boolean) => void;
}

const ApplicationContext = React.createContext<PropsWithChildren<StrapiForm>>({
	application: {},
	schulJahrDetails: {},
	setApplicationProperty: (_key: string, _value: any) => {},
	saveApplication: (_submit?: boolean, _newApplication?: boolean | any, _changeLastEdited?: boolean) => {},
	handlePrint: () => { },
	readOnly: false,
	printMode: false,
	tree: [],
	errors: [],
	// setCheckboxChecked: (_checked: boolean) => {}, // Provides a default no-op function
});

const ApplicationContextProvider: FC<PropsWithChildren<StrapiForm>> = ({
	children,
	application = {},
	schulJahrDetails = {},
	setApplicationProperty = (_key: string, _value: any) => {},
	saveApplication = (_submit: boolean = false, _newApplication: boolean | any = false, _changeLastEdited: boolean = true) => {},
	handlePrint = () => { },
	readOnly = false,
	printMode= false,
	tree = [],
	errors = [],
}) => {

	return (
		<ApplicationContext.Provider
			value={{
				application,
				schulJahrDetails,
				setApplicationProperty,
				saveApplication,
				handlePrint,
				readOnly,
				printMode,
				tree,
				errors,
			}}
		>
			{children}
		</ApplicationContext.Provider>
	);
};

export default ApplicationContextProvider;

function useApplication() {
	const context = React.useContext(ApplicationContext);
	if (context === undefined) {
		throw new Error('useApplication must be used within a ApplicationContextProvider');
	}
	return context;
}

export { useApplication };
